import { render, staticRenderFns } from "./AppleStoreBadge.vue?vue&type=template&id=14085a3c&"
import script from "./AppleStoreBadge.vue?vue&type=script&lang=js&"
export * from "./AppleStoreBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14085a3c')) {
      api.createRecord('14085a3c', component.options)
    } else {
      api.reload('14085a3c', component.options)
    }
    module.hot.accept("./AppleStoreBadge.vue?vue&type=template&id=14085a3c&", function () {
      api.rerender('14085a3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppleStoreBadge.vue"
export default component.exports